import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import TurmaDisciplinaProfessorProfileInfo from './TurmaDisciplinaProfessorProfileInfo';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '100%',
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function TurmaDisciplinaProfessorProfile({ tdp, onTdpSelected }) {
    const classes = useStyles();

    const handleTrocaTdp = () => {
        onTdpSelected(null)
    }

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <TurmaDisciplinaProfessorProfileInfo
                    tdp={tdp} />
                <CardActions>
                    <Button
                        onClick={handleTrocaTdp}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >Trocar Turma/Disciplina</Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}